module.exports = __webpack_public_path__ + "static/media/coconutspinachtempeh.6ebbe441.jpg";